import { useCallback, useEffect, useState } from "react";
import { CardContent as CardContentMUI, Divider, Stack, Typography } from "@mui/material";
import DisablePhoneButton from "./components/DisablePhoneButton";
import EditPhoneNumberButton from "./components/EditPhoneNumberButton";
import ShowPhoneNumber from "./components/ShowPhoneNumber";
import VerifyPhoneButton from "./components/VerifyPhoneButton";
import {
  phoneActionsStackSx,
  phoneSectionBoxSx,
  phoneSectionDividerSx,
} from "./components/ManagePhone.styles";
import { useAuthStore } from "../../store/zustand/authStore";

const NULL_PHONE = null;

const ManagePhone = ({ user }) => {

  const sessionUser = useAuthStore((state) => state.user);

  const hasPermissionEditUser = Boolean(sessionUser?.admin_users?.USERS?.WRITE?.[0]);

  const [phone, setPhone] = useState(user?.phone ?? null);
  const [phone_verified, setPhone_verified] = useState(Boolean(user?.phone_verified));

  const applyPhoneDisabled = useCallback((verified) => {
    setPhone_verified(Boolean(verified));
    if (!verified) setPhone(NULL_PHONE);
  }, []);

  const applyPhoneEdit = useCallback((next) => {
    setPhone(next);
    setPhone_verified(false);
  }, []);

  return (
    <CardContentMUI sx={phoneSectionBoxSx}>
      <Typography variant="h6">
        Gestión de Teléfono
      </Typography>

      <Divider sx={phoneSectionDividerSx} />
      
      <ShowPhoneNumber phone={phone} phoneVerified={phone_verified} />

      {hasPermissionEditUser && (
        <Stack sx={phoneActionsStackSx}>

          <EditPhoneNumberButton userId={user.id} setPhone={applyPhoneEdit} />
          
          {!phone_verified && (
            <VerifyPhoneButton userId={user.id} phone={phone} setPhone_verified={setPhone_verified} />
          )}
          
          {phone && (
            <DisablePhoneButton userId={user.id} setPhone_verified={applyPhoneDisabled} />
          )}

        </Stack>
      )}
     
    </CardContentMUI>
  );
};

export default ManagePhone;
